// extracted by mini-css-extract-plugin
module.exports = {"registerInterfaceWrapper":"CreateAccountForm_registerInterfaceWrapper__IF6tj","accountTypeSelector":"CreateAccountForm_accountTypeSelector__wUawr"};